import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=cfd1cae2&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd1cae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfd1cae2')) {
      api.createRecord('cfd1cae2', component.options)
    } else {
      api.reload('cfd1cae2', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=cfd1cae2&scoped=true&", function () {
      api.rerender('cfd1cae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iBD7Wmt8UMNZ/JS/comp/Accordion.vue"
export default component.exports